import { useCallback, useEffect } from "react";

import { PATH } from "@/shared/models/const/path";
import useUserHelp from "@rf-hooks/useUserHelp";
import useAlert from "@rf-hooks/useAlert";
import { useNavigate } from "react-router-dom";
import debounce from "lodash/debounce";

const useProfileCompleteEvaluation = () => {
  const { USER, USER_ROLE } = useUserHelp();
  const { alert } = useAlert();
  const navigate = useNavigate();

  const dbFunction = debounce(() => {
    CheckProfileCompleteFn();
  }, 300);

  const CheckProfileCompleteFn = useCallback(() => {
    console.log(
      "USER",
      !USER.userData?.is_profile_finished,
      !USER_ROLE.SUPER_ADMIN,
      !USER_ROLE.ADMIN
    );
    if (
      !USER.userData?.is_profile_finished &&
      !USER_ROLE.SUPER_ADMIN &&
      !USER_ROLE.ADMIN
    ) {
      alert({
        type: "warning",
        color: "primary.main",
        title: "¡ALERTA! Actualización de perfil requerida",
        message:
          "Hemos ampliado los datos necesarios en su perfil debido a mejoras en la plataforma. Para evitar la suspensión de su cuenta, por favor actualice la información lo antes posible.",
        confirmBtnMessage: "Ir a completar mi perfil"
      })
        .then(e => {
          if (e.type.confirm) {
            navigate(PATH.PRIVATE.PROFILE.EDIT(USER.userData?.people_id!));
          }
        })
        .catch(() => {});
    }
  }, [USER, USER_ROLE, alert, navigate]);

  return {
    CheckProfileComplete: dbFunction
  };
};

export default useProfileCompleteEvaluation;
